package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.ToysAndGamesW500Rounded: ImageVector
    get() {
        if (_toysAndGamesW500Rounded != null) {
            return _toysAndGamesW500Rounded!!
        }
        _toysAndGamesW500Rounded = Builder(name = "ToysAndGamesW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(112.59f, 688.0f)
                quadToRelative(0.0f, -18.87f, 12.65f, -32.14f)
                reflectiveQuadTo(156.0f, 642.59f)
                quadToRelative(8.96f, 0.0f, 17.29f, 2.86f)
                quadToRelative(8.34f, 2.85f, 16.3f, 8.33f)
                quadToRelative(11.8f, 7.29f, 24.08f, 13.05f)
                quadToRelative(12.29f, 5.76f, 26.33f, 5.76f)
                quadToRelative(29.89f, 0.0f, 51.24f, -21.35f)
                reflectiveQuadTo(312.59f, 600.0f)
                quadToRelative(0.0f, -29.89f, -21.35f, -51.24f)
                reflectiveQuadTo(240.0f, 527.41f)
                quadToRelative(-14.04f, 0.0f, -26.85f, 4.76f)
                quadToRelative(-12.8f, 4.76f, -22.37f, 13.33f)
                quadToRelative(-7.91f, 6.43f, -16.51f, 9.17f)
                quadToRelative(-8.6f, 2.74f, -18.27f, 2.74f)
                quadToRelative(-17.39f, 0.0f, -30.4f, -13.27f)
                quadToRelative(-13.01f, -13.27f, -13.01f, -32.14f)
                verticalLineToRelative(-155.59f)
                quadToRelative(0.0f, -18.43f, 12.69f, -31.13f)
                quadToRelative(12.7f, -12.69f, 31.13f, -12.69f)
                horizontalLineToRelative(144.74f)
                quadToRelative(-4.28f, -13.09f, -6.42f, -26.3f)
                quadToRelative(-2.14f, -13.2f, -2.14f, -26.29f)
                quadToRelative(0.0f, -78.11f, 54.65f, -132.76f)
                quadToRelative(54.65f, -54.65f, 132.76f, -54.65f)
                quadToRelative(78.11f, 0.0f, 132.76f, 54.65f)
                quadToRelative(54.65f, 54.65f, 54.65f, 132.76f)
                quadToRelative(0.0f, 13.09f, -2.14f, 26.29f)
                quadToRelative(-2.14f, 13.21f, -6.42f, 26.3f)
                horizontalLineToRelative(144.74f)
                quadToRelative(18.43f, 0.0f, 31.13f, 12.69f)
                quadToRelative(12.69f, 12.7f, 12.69f, 31.13f)
                lineTo(847.41f, 512.0f)
                quadToRelative(0.0f, 19.87f, -13.77f, 33.64f)
                reflectiveQuadTo(800.0f, 559.41f)
                quadToRelative(-9.43f, 0.0f, -16.51f, -3.86f)
                quadToRelative(-7.08f, -3.85f, -14.27f, -10.05f)
                quadToRelative(-10.05f, -9.04f, -22.85f, -13.57f)
                quadToRelative(-12.8f, -4.52f, -26.37f, -4.52f)
                quadToRelative(-29.89f, 0.0f, -51.24f, 21.35f)
                reflectiveQuadTo(647.41f, 600.0f)
                quadToRelative(0.0f, 29.89f, 21.35f, 51.24f)
                reflectiveQuadTo(720.0f, 672.59f)
                quadToRelative(13.57f, 0.0f, 26.25f, -4.52f)
                quadToRelative(12.68f, -4.53f, 22.97f, -13.57f)
                quadToRelative(5.95f, -5.72f, 13.41f, -9.82f)
                quadToRelative(7.46f, -4.09f, 17.37f, -4.09f)
                quadToRelative(19.87f, 0.0f, 33.64f, 13.77f)
                reflectiveQuadTo(847.41f, 688.0f)
                verticalLineToRelative(155.59f)
                quadToRelative(0.0f, 18.43f, -12.69f, 31.13f)
                quadToRelative(-12.7f, 12.69f, -31.13f, 12.69f)
                lineTo(156.41f, 887.41f)
                quadToRelative(-18.43f, 0.0f, -31.13f, -12.69f)
                quadToRelative(-12.69f, -12.7f, -12.69f, -31.13f)
                lineTo(112.59f, 688.0f)
                close()
                moveTo(200.0f, 800.0f)
                horizontalLineToRelative(560.0f)
                verticalLineToRelative(-46.0f)
                quadToRelative(-9.76f, 3.0f, -19.38f, 4.5f)
                reflectiveQuadTo(720.0f, 760.0f)
                quadToRelative(-66.0f, 0.0f, -113.0f, -47.0f)
                reflectiveQuadToRelative(-47.0f, -113.0f)
                quadToRelative(0.0f, -66.0f, 47.0f, -113.0f)
                reflectiveQuadToRelative(113.0f, -47.0f)
                quadToRelative(11.0f, 0.0f, 20.62f, 1.5f)
                quadToRelative(9.62f, 1.5f, 19.38f, 4.5f)
                verticalLineToRelative(-46.0f)
                lineTo(578.0f, 400.0f)
                quadToRelative(-17.0f, 0.0f, -28.5f, -10.88f)
                reflectiveQuadTo(538.0f, 362.0f)
                quadToRelative(0.0f, -8.24f, 2.62f, -16.62f)
                reflectiveQuadTo(550.0f, 332.0f)
                quadToRelative(17.0f, -12.0f, 23.5f, -31.5f)
                reflectiveQuadTo(580.0f, 260.0f)
                quadToRelative(0.0f, -42.0f, -29.0f, -71.0f)
                reflectiveQuadToRelative(-71.0f, -29.0f)
                quadToRelative(-42.0f, 0.0f, -71.0f, 29.0f)
                reflectiveQuadToRelative(-29.0f, 71.0f)
                quadToRelative(0.0f, 21.0f, 6.5f, 40.5f)
                reflectiveQuadTo(410.0f, 332.0f)
                quadToRelative(6.76f, 5.0f, 9.38f, 12.5f)
                quadTo(422.0f, 352.0f, 422.0f, 360.0f)
                quadToRelative(0.0f, 17.0f, -11.5f, 28.5f)
                reflectiveQuadTo(382.0f, 400.0f)
                lineTo(200.0f, 400.0f)
                verticalLineToRelative(46.0f)
                quadToRelative(9.76f, -3.0f, 19.38f, -4.5f)
                reflectiveQuadTo(240.0f, 440.0f)
                quadToRelative(66.0f, 0.0f, 113.0f, 47.0f)
                reflectiveQuadToRelative(47.0f, 113.0f)
                quadToRelative(0.0f, 66.0f, -47.0f, 113.0f)
                reflectiveQuadToRelative(-113.0f, 47.0f)
                quadToRelative(-11.0f, 0.0f, -20.62f, -1.5f)
                quadToRelative(-9.62f, -1.5f, -19.38f, -4.5f)
                verticalLineToRelative(46.0f)
                close()
                moveTo(480.0f, 480.0f)
                close()
            }
        }
        .build()
        return _toysAndGamesW500Rounded!!
    }

private var _toysAndGamesW500Rounded: ImageVector? = null
